/**
 * 用户登录模块
 * @author fulh
 * @create 2016-08-19 14:49:52
 */

$.module('MM.user.login', function () {
  var TMPL_FORCE_LOGIN =
    '\
        <div class="full-screen-mask"></div>\
        <div class="nologin-wrapper">\
            <div class="zhi-wrold bg-common"></div>\
            <div class="word-text bg-common"></div>\
            <div class="blink-tip bg-common">\
                <div class="part-1 bg-common"></div>\
                <div class="part-2 bg-common"></div>\
                <div class="part-3 bg-common"></div>\
                <div class="qq-login bg-common" onclick="MM.user.redirectToLogin(\'qq\')"></div>\
                <div  class="other-login bg-common j_popup_login"></div>\
            </div>\
            <div class="nologin-focus"><input checked="true" type="checkbox">\
                <span> 关注 </span><span class="start-name">(  )</span></div>\
            <a alt="" href="/"><div class="nologin-exit bg-common"></div></a>\
        </div>\
    ';

  var LIVE_ROOM_KEY_FOCUS_STAR = 'LIVE_ROOM_KEY_FOCUS_STAR';
  var USER_PRIVACY = 'USER_PRIVACY';

  var ACTIONS = {
    authcode: MM.core.getRoot('authcode/fetch', 'user'),
    getRefreshtoken:
      'api/v3/oauth2/token?grant_type=password&event_seq_id={event_seq_id}&scope=PC_WEB',

    login: MM.core.getRoot(
      'login?login_name={login_name}&pwd={pwd}&auth_key={auth_key}&auth_code={auth_code}',
      'user',
    ),
    login_gt: MM.core.getRoot(
      'login?login_name={login_name}&pwd={pwd}&geetest_challenge={geetest_challenge}&geetest_validate={geetest_validate}&geetest_seccode={geetest_seccode}',
      'user',
    ),
    // loginNew: 'login?login_name={login_name}&pwd={pwd}',
  };
  /**
   * 用户登录框控制模块
   */
  var $popLoginArea;
  var $errorTip;
  var _loginCallback;

  function _handleLogin() {
    var data = $.serializeForm($popLoginArea);
    _checkFormData(data);

    var $btn = $popLoginArea.find('.btn-login');

    if ($btn.hasClass('btn-disabled')) {
      return;
    }

    if ($errorTip.text()) {
      // 存在错误 返回
      return;
    }

    var btn_text = $btn.html();

    $btn.addClass('btn-disabled').text('数据提交中……');

    var success = function (res) {
      if (res.data.en_mobile && !res.data.security_checks) {
        MM.user.register.popupRegister('safeCheck', res.data);
        $btn.removeClass('btn-disabled').html(btn_text);
      } else {
        MM.user.refreshToken.save(res.data);
        MM.log.send({
          event: 'user',
          event_type: 'login_success',
        });

        storeLoginInfo('set', data);

        // console.log(res.data)
        // return
        MM.user.getExtraUserInfo(function () {
          MM.log.send({
            event: 'user',
            event_type: 'login_success',
          });

          $btn.removeClass('btn-disabled').html('登录成功');
          // location.reload();
          _loginCallback();
        });
      }
    };

    var error = function (res) {
      var code = _.get(res, 'code');
      if (code === 30419) {
        // 手动清除缓存 服务器会报 30419 错误 【验证码错误】
        MM.ui.messager.warn('登录次数过于频繁，请重新登录', function () {
          loginRequestByGeet(); // 直接使用极验证
        });
      }
      var errorMsgs = {
        30402: '用户名或密码错误，超过5次错误，对应账号将被冻结',
        30403: '密码输入错误过多，账号已被冻结，请30分钟后重试',
        30404: '该用户已被冻结，有任何疑问请联系客服',
        1006: '该用户已注销，无法登录',
      };

      var msg = errorMsgs[code] || res.msg || res.message || '用户名或密码错误';

      MM.log.send({
        event: 'user',
        event_type: 'login_error',
        content: {
          code: code,
          msg: msg,
        },
      });

      $errorTip.text(msg);
      $btn.removeClass('btn-disabled').html(btn_text);
    };

    var logintype = {
      grant_type: 'password',
      scope: 'PC_WEB',
    };
    data.password = MM.common.encryptedDES(data.password);

    loginRequestByGeet();

    function loginRequestByGeet() {
      // 上报登录事件
      var seqid = MM.util.sdata.trackWithSeqId('sign', { logintype: '手机号' });
      data.event_seq_id = seqid;
      MM.common.geetestRquest('login', {
        type: 'POST',
        url: ACTIONS.getRefreshtoken,
        urlType: 'amber',
        data: _.merge(logintype, data),
        success: success,
        error: error,
        disableCommonErrorHandler: true,
        // disableOnTest: true,
        onClose: function () {
          $btn.removeClass('btn-disabled').html(btn_text);
        },
      });
    }
  }

  /**
   * 处理记住密码逻辑
   * @param {String} type
   * @param {Object} source
   */
  function storeLoginInfo(type, source) {
    var separator = '==&&==';
    var isStore = $popLoginArea
      .find('.extra-form-content .fl')
      .hasClass('active');

    if (type === 'set' && !isStore) {
      return;
    }

    if (type == 'get') {
      var loginInfo = MM.common.getCookie(USER_PRIVACY) || '';
      var info = String(decodeURIComponent(loginInfo)).split(separator) || [];
      var username = info[1];

      if (info.length !== 2 || !username) {
        // 存储数据丢失 不处理
        return;
      }

      // 处理记住密码逻辑
      $popLoginArea
        .find('.extra-form-content .fl')
        .removeClass('active')
        .addClass('active');
      $popLoginArea.find('input[name="username"]').val(username);
      $popLoginArea
        .find('input[name="password"]')
        .val(MM.common.encode(info[0], username))
        .prop('type', 'password');

      return;
    }

    var storedUserInfo = encodeURIComponent(
      MM.common.encode(source.password, source.username) +
        separator +
        source.username,
    );

    // 记住密码7天过期
    MM.common.setCookie(USER_PRIVACY, storedUserInfo, 7 * 24 * 60 * 60 * 1000);
  }

  function _goLogin() {
    window.location.href =
      '/?action=login&referrer=' + encodeURIComponent(location.href);
  }

  /**
   * 判断是否是第二次进行注册或者登录操作（1小时内）
   * @param  {String}  key 储存的缓存字段
   * @return {Boolean}
   */
  var _loginTag = 'LOGIN_COUNT';

  // $(function(){ _popupLogin({ type: 'thirdLogin', force: true }) })
  function _popupLogin(typeObject, success) {
    _loginCallback =
      typeof success == 'function'
        ? success
        : function () {
            if ($.query.get('referrer')) {
              location.href = $.query.get('referrer');
            } else {
              location.reload();
            }
          };

    if (typeObject === 'loginForm') {
      MM.user.popup.show(typeObject, function ($popup) {
        $popLoginArea = $popup.find('.login-form-content');
        $errorTip = $popLoginArea.find('.error-tip');
        storeLoginInfo('get');
        _bindEvents();
      });
    }

    MM.user.popup.show(typeObject || 'thirdLogin');
  }

  function _bindEvents() {
    $popLoginArea
      .on('click', '.btn-login', function (e) {
        _handleLogin();
      })
      .on('click', '.btn-forgot-password', function (e) {
        MM.ui.messager.warn('请前往手机端进行忘记密码操作');
      })
      .on('keyup', 'input', function (e) {
        if (e.keyCode !== 13) return;
        $(this).blur();
        _handleLogin();
      })
      .on('focus', 'input', function () {
        $errorTip.text('');
      })
      .on('click', '.extra-form-content .fl', function () {
        $(this).toggleClass('active');
      })
      .on('blur', '.ui-form-input', function (e) {
        var $this = $(this);
        var name = $this.attr('name');
        var formData = {};
        formData[name] = $this.val();
        _checkFormData(formData);
      });
  }

  function _checkFormData(data) {
    var tipText = '';
    if (typeof data.username !== 'undefined' && !data.username) {
      tipText = '请输入手机号/用户名/么么号';
    } else if (typeof data.password !== 'undefined') {
      if (!data.password) {
        tipText = '请输入密码';
      } else if (data.password.length < 6) {
        tipText = '请输入正确的密码';
      }
    }
    tipText && $errorTip.text(tipText);
  }

  function _forceLogin() {
    $('body').append(TMPL_FORCE_LOGIN);
    $('#page').addClass('page-filter');

    $('.nologin-focus .start-name').html(
      '( ' + MM.live.room.getRoomUserInfo().nick_name + ' )',
    );
    $.store.set(LIVE_ROOM_KEY_FOCUS_STAR, MM.live.room.getRoomId());
    $('.nologin-focus input').change(function () {
      if ($('.nologin-focus input').is(':checked')) {
        $.store.set(LIVE_ROOM_KEY_FOCUS_STAR, MM.live.room.getRoomId());
      } else {
        $.store.set(LIVE_ROOM_KEY_FOCUS_STAR, false);
      }
    });
  }

  function _focusStarBuyForceLogin(roomType) {
    var isfocus =
      $.store.get(LIVE_ROOM_KEY_FOCUS_STAR) == MM.live.room.getRoomId() ||
      false;
    var $focus = undefined;
    if (roomType == 'live_v2') {
      $focus = $('.star-nums-follow a');
      if (MM.user.isLogin() && isfocus && !$focus.hasClass('on')) {
        $focus.click();
      }
    } else {
      $focus = $('a.liveinfo-area-follow');
      if (MM.user.isLogin() && isfocus && !$focus.hasClass('btn-default')) {
        $focus.click();
      }
    }
    $.store.set(LIVE_ROOM_KEY_FOCUS_STAR, false);
  }

  return {
    goLogin: _goLogin,
    forceLogin: _forceLogin,
    focusStarBuyForceLogin: _focusStarBuyForceLogin,
    popupLogin: _popupLogin,
  };
});
